/* eslint-disable @typescript-eslint/ban-ts-comment */
//@ts-nocheck
import dayjs from 'dayjs';
import { FC } from 'react';

import { Box, Flex, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';

import { useGetBookingTypeData } from '@/shared/hooks/useGetBookingTypeData';
import useAppStore from '@/shared/store/app.store';
import { BookingType, IObject } from '@/shared/types/bookingObjects.types';
import { TPersonalPlaceActive } from '@/shared/types/personalPlaces.types';
import { BottomSheet } from '@/shared/uikit/components/bottomSheet';
import { MapButton } from '@/shared/uikit/components/button/mapButton';
import { ContentCheckbox } from '@/shared/uikit/components/checkbox/contentCheckbox';
import { ModalSheet } from '@/shared/uikit/components/modalSheet';
import { IconicRow } from '@/shared/uikit/components/rows/IconicRow';

import { PersonalPlaceActions } from './PersonalPlaceActions';
import { PersonalPlaceEdit } from './PersonalPlaceEdit';

type ActiveBookingSelectedProps = {
	object: IObject & TPersonalPlaceActive;
	type?: 'detail' | 'free' | 'limited';
};

export const PersonalPlaceDetail: FC<ActiveBookingSelectedProps> = ({
	object,
	type = 'detail',
}) => {
	const isMobile = useAppStore((state) => state.isMobile);
	const objectType = useGetBookingTypeData({
		bookingType: object?.type.kind as BookingType,
	});
	const actionType = dayjs().isBetween(object.start, object.finish) ? 'end' : 'cancel';

	const [openedFreeAccess, { close: closeFreeAccess, open: openFreeAccess }] = useDisclosure(false);

	// const [openedLimitedAccess, { close: closeLimitedAccess, open: openLimitedAccess }] =
	// 	useDisclosure(false);

	const [openedFreeAccessEdit, { close: closeFreeAccessEdit, open: openFreeAccessEdit }] =
		useDisclosure(false);

	// const [openedLimitedAccessEdit, { close: closeLimitedAccessEdit, open: openLimitedAccessEdit }] =
	// 	useDisclosure(false);

	const [openedEditActions, { close: closeEditActions, open: openEditActions }] =
		useDisclosure(false);

	return (
		<>
			<Flex direction="column" gap={24}>
				<Box>
					<ContentCheckbox
						label={objectType?.label}
						leftIcon={objectType?.icon}
						subtitle="Персональное место"
						checked
					/>
				</Box>

				{type === 'detail' && (
					<>
						<IconicRow
							mainText="Свободный доступ"
							dimmedText="Открыть доступ всем желающим на определенный срок"
							{...(object?.active && { badge: 'Активно' })}
							onClick={object?.active ? openFreeAccess : openFreeAccessEdit}
							clickable
						/>
					</>
				)}

				{type !== 'detail' && (
					<Flex direction="column" gap={8}>
						<Text size="xl" fw={800}>
							Дата и время
						</Text>
						<Flex gap={16}>
							<Flex direction="column" pr={10}>
								<Text c="#667085" size="sm" fw={500} tt="uppercase">
									Дата
								</Text>
								<Text fw={600}>
									{dayjs(object?.start).date() === dayjs(object?.finish).date()
										? `${dayjs(object?.start).format('DD MMM')}`
										: `С ${dayjs(object?.start).format('DD MMM')} до ${dayjs(object?.finish).format('DD MMM')}`}
								</Text>
							</Flex>
							<Flex direction="column" pr={10}>
								<Text c="#667085" size="sm" fw={500} tt="uppercase">
									Время
								</Text>
								<Text fw={600}>
									{`${dayjs(object?.start).format('HH:mm')} - ${dayjs(object?.finish).format('HH:mm')}`}
								</Text>
							</Flex>
						</Flex>
					</Flex>
				)}

				<Flex direction="column" gap={8}>
					<Text size="xl" fw={800}>
						Локация
					</Text>
					<Flex gap={16}>
						<Flex direction="column">
							<Text c="#667085" size="sm" fw={500} tt="uppercase">
								Офис и этаж
							</Text>
							<Text fw={600}>
								{object.description}
								{/* {getBookingParentNames(booking?.booking_object)} */}
							</Text>
						</Flex>
					</Flex>
					<Flex gap={16}>
						<Flex direction="column">
							<Text c="#667085" size="sm" fw={500} tt="uppercase">
								{objectType?.label}
							</Text>
							<Text fw={600}>
								{
									//TODO: edit response to get work place/parking/meeting room number
									object.name.replace(/([\s|А-Яа-я]+)|(\d-)/gm, '')
								}
							</Text>
						</Flex>
					</Flex>
				</Flex>
				<MapButton objects={object} text="Открыть на карте" showOnMap />
			</Flex>

			{isMobile ? (
				<BottomSheet
					opened={openedFreeAccess}
					onClose={closeFreeAccess}
					title="Свободный доступ"
					buttons={[
						{
							children: actionType === 'cancel' ? 'Отменить' : 'Завершить',
							variant: 'default',
							onClick: openEditActions,
						},
						{
							children: 'Редактировать',
							onClick: openFreeAccessEdit,
						},
					]}
					withCloseButton={false}
					withBackButton
					isFullScreen
				>
					<PersonalPlaceDetail object={object} type="free" />
				</BottomSheet>
			) : (
				<ModalSheet
					opened={openedFreeAccess}
					onClose={closeFreeAccess}
					title="Свободный доступ"
					buttons={[
						{
							children: actionType === 'cancel' ? 'Отменить' : 'Завершить',
							variant: 'default',
							onClick: openEditActions,
						},
						{
							children: 'Редактировать',
							onClick: openFreeAccessEdit,
						},
					]}
					withCloseButton={false}
					size="lg"
					centered
				>
					<PersonalPlaceDetail object={object} type="free" />
				</ModalSheet>
			)}

			{/* <BottomSheet
				opened={openedLimitedAccess}
				onClose={closeLimitedAccess}
				title="Ограниченный доступ"
				buttons={[
					{
						children: actionType === 'cancel' ? 'Отменить' : 'Завершить',
						variant: 'default',
						// onClick: openActions,
					},
					{
						children: 'Редактировать',
						color: 'green',
						// onClick: openEdit
					},
				]}
				withCloseButton={false}
				withBackButton
				isFullScreen
			>
				<PersonalPlaceDetail object={object} type="limited" />
			</BottomSheet> */}

			{openedFreeAccessEdit && (
				<PersonalPlaceEdit
					object={object}
					opened={openedFreeAccessEdit}
					close={closeFreeAccessEdit}
					type="editFree"
					isAccess={object?.active}
				/>
			)}

			{/* {openedLimitedAccessEdit && (
				<PersonalPlaceEdit
					object={object}
					opened={openedFreeAccessEdit}
					close={closeLimitedAccessEdit}
					type="editLimited"
					isAccess={object?.active}
				/>
			)} */}

			{object.release_id && (
				<PersonalPlaceActions
					id={object.release_id}
					type={actionType}
					opened={openedEditActions}
					close={closeEditActions}
				/>
			)}
		</>
	);
};
